<script lang="ts">
let listenersBoundForToken: string | null = null;
</script>

<script lang="ts" setup>
import {onMounted} from "vue";

import FadeTransition from "@src/components/ui/transitions/FadeTransition.vue";
import MainMenu from "@src/components/views/HomeView/MainMenu/MainMenu.vue";
import Sidebar from "@src/components/views/HomeView/Sidebar/Sidebar.vue";
import Kanban from "@src/components/views/HomeView/Kanban/Kanban.vue";
import ScheduleMessages from "@src/components/views/HomeView/ScheduleMessages/ScheduleMessages.vue";
import {NewGroupMessageListener} from "@src/eventListeners/NewGroupMessageListener";
import {ActiveSessionListener} from "@src/eventListeners/ActiveSessionListener";
import {NewMessageListener} from "@src/eventListeners/NewMessageListener";

import {useChatSessionStore} from "@src/stores/chatSession";
import useStore from "@src/stores/store";
import {useAuthStore} from "@src/stores/auth";
import {TagsUpdatedSessionListener} from "@src/eventListeners/TagsUpdatedSessionListener";
import {ReactionListener} from "@src/eventListeners/ReactionListener";
import {ChannelStatusUpdatedListener} from "@src/eventListeners/ChannelStatusUpdatedListener";
import {MessageStatusListener} from "@src/eventListeners/MessageStatusListener";
import {StartConversationListener} from "@src/eventListeners/StartConversationListener";
import {EndSessionListener} from "@src/eventListeners/EndSessionListener";
import {TransferSessionListener} from "@src/eventListeners/TransferSessionListener";
import {NotifySessionWasTransferredListener} from "@src/eventListeners/NotifySessionWasTransferredEvent";
import {KanbanUpdatedSessionListener} from "@src/eventListeners/KanbanUpdatedSessionListener";
import {HoldingSessionListener} from "@src/eventListeners/HoldingSessionListener";
import {FixedSessionListener} from "@src/eventListeners/FixedSessionListener";
import {ArchiveSessionListener} from "@src/eventListeners/ArchiveSessionListener";
import {NewBotMessageListener} from "@src/eventListeners/NewBotMessageListener";
import {botSessionExpiredListener} from "@src/eventListeners/botSessionExpiredListener";
import {SessionTransferredCleanupListener} from "@src/eventListeners/SessionTransferredCleanupListener";
import {HasNewMessageSetSessionEvent} from "@src/eventListeners/HasNewMessageSetSessionEvent";
import {ExpirationSessionListener} from "@src/eventListeners/ExpirationSessionListener";
import {EditMessageListener} from "@src/eventListeners/EditMessageListener";
import {InternalChatListeners} from "@src/eventListeners/InternalChatListeners";
import InternalChat from "@src/components/views/HomeView/InternalChat/InternalChat.vue";


const store = useStore()

const sessionStore = useChatSessionStore();
const auth = useAuthStore();

onMounted(() => {
    const currentToken = localStorage.getItem('dchatToken');
    if (listenersBoundForToken === currentToken) return;

    // segurança extra: só tenta ligar se já tem user
    if (!auth.user?.id) return;

    // segurança extra: garante que o Echo já foi inicializado
    // @ts-ignore
    if (!window.websockets) {
        console.warn("⚠️ Echo ainda não inicializado (window.websockets undefined).");
        return;
    }


    // session
    ActiveSessionListener();
    ArchiveSessionListener();
    EndSessionListener();
    FixedSessionListener();
    HoldingSessionListener();
    KanbanUpdatedSessionListener();
    NotifySessionWasTransferredListener();
    StartConversationListener();
    TagsUpdatedSessionListener();
    TransferSessionListener();
    botSessionExpiredListener();
    SessionTransferredCleanupListener();
    HasNewMessageSetSessionEvent();
    ExpirationSessionListener();

    // message
    NewMessageListener();
    NewBotMessageListener();
    NewGroupMessageListener();
    ReactionListener();
    MessageStatusListener()
    EditMessageListener()
    // others
    ChannelStatusUpdatedListener();
    InternalChatListeners();

    listenersBoundForToken = currentToken;
});

</script>

<template>
    <div class="xs:relative h-full flex xs:flex-col md:flex-row overflow-hidden ">
        <!-- menu-bar -->
        <MainMenu :class="!sessionStore.selectedSession ? 'xs:order-1 md:order-0' : 'xs:hidden md:order-0 md:flex'"
                  class="col-span-1 relative z-50"/>

        <!-- session-list -->
        <Sidebar v-if="store.activeSidebarComponent !== 'kanban' && store.activeSidebarComponent !== 'schedule-messages' && store.activeSidebarComponent !== 'internal-chat'"
                 class="order-0 relative z-10 xs:grow-1 md:grow-0 xs:overflow-y-scroll md:overflow-visible scrollbar-hidden"/>
        <!-- chat -->
        <div v-if="store.activeSidebarComponent !== 'kanban' && store.activeSidebarComponent !== 'schedule-messages' && store.activeSidebarComponent !== 'internal-chat'"
             id="mainContent"
             :class="sessionStore.selectedSession ? 'xs:absolute xs:z-10 md:static' : 'xs:hidden md:block'"
             class="grow h-full xs:w-full md:w-fit scrollbar-hidden bg-white dark:bg-gray-800 transition-all duration-500 relative z-0"
             role="region">
            <FadeTransition mode="out-in" name="fade">
                <component :is="sessionStore.currentComponent"/>
            </FadeTransition>
        </div>

        <FadeTransition mode="out-in" name="fade">
            <kanban v-if="store.activeSidebarComponent === 'kanban'">
            </kanban>
        </FadeTransition>

        <FadeTransition mode="out-in" name="fade">
            <ScheduleMessages v-if="store.activeSidebarComponent === 'schedule-messages'">
            </ScheduleMessages>
        </FadeTransition>

        <InternalChat v-if="store.activeSidebarComponent === 'internal-chat'" class="grow h-full"/>
    </div>
</template>

<style scoped>
</style>